export const COLLAPSE_CLASSNAME = 'ReactCollapse--collapse'
export const CONTENT_CLASSNAME = 'ReactCollapse--content'
export const COLLAPSE_DURATION = 500
